(function () {
  const campaignKeys = [
    "utm_source", "utm_medium", "utm_campaign", "utm_content", "utm_term",
    "gclid", "gbraid", "wbraid", "fbclid", "msclkid", "ttclid"
  ];
  const landingParams = new URLSearchParams(window.location.search);
  const campaign = {};

  campaignKeys.forEach((key) => {
    const value = landingParams.get(key);
    if (value) campaign[key] = value.slice(0, 250);
  });

  try {
    const storedCampaign = JSON.parse(sessionStorage.getItem("rush_campaign") || "{}");
    window.RushCampaign = { ...storedCampaign, ...campaign };
    if (Object.keys(campaign).length) {
      sessionStorage.setItem("rush_campaign", JSON.stringify(window.RushCampaign));
      sessionStorage.setItem("rush_landing_page", window.location.pathname);
    }
  } catch (error) {
    window.RushCampaign = campaign;
  }

  document.addEventListener("click", (event) => {
    const cta = event.target.closest("[data-rush-cta]");
    if (!cta) return;

    const detail = {
      event: "rush_cta_click",
      cta_name: cta.dataset.rushCta,
      cta_label: cta.dataset.rushCtaLabel || cta.textContent.trim().replace(/\s+/g, " ").slice(0, 120),
      platform: cta.dataset.rushPlatform || undefined,
      destination: cta.getAttribute("href") || undefined,
      page_path: window.location.pathname,
      campaign: window.RushCampaign || {}
    };

    window.dataLayer = window.dataLayer || [];
    window.dataLayer.push(detail);
    document.dispatchEvent(new CustomEvent("rush:cta-click", { detail }));
  });

  const menuToggle = document.querySelector("[data-menu-toggle]");
  const mobileMenu = document.querySelector("[data-mobile-menu]");

  if (menuToggle && mobileMenu) {
    const setMenuOpen = (isOpen) => {
      mobileMenu.classList.toggle("is-open", isOpen);
      menuToggle.setAttribute("aria-expanded", String(isOpen));
      document.body.classList.toggle("rush-menu-open", isOpen);
    };

    menuToggle.addEventListener("click", () => {
      setMenuOpen(menuToggle.getAttribute("aria-expanded") !== "true");
    });

    mobileMenu.querySelectorAll("a").forEach((link) => {
      link.addEventListener("click", () => setMenuOpen(false));
    });

    document.addEventListener("keydown", (event) => {
      if (event.key === "Escape") setMenuOpen(false);
    });
  }

  document.querySelectorAll("[data-product-shelf]").forEach((shelf) => {
    const showcase = shelf.closest("[data-product-showcase]");
    const previousButton = showcase?.querySelector('[data-shelf-scroll="previous"]');
    const nextButton = showcase?.querySelector('[data-shelf-scroll="next"]');

    const getScrollDistance = () => {
      const firstCard = shelf.querySelector(".rush-product-card");
      if (!firstCard) return 0;
      const shelfGap = Number.parseFloat(window.getComputedStyle(shelf).columnGap) || 0;
      return firstCard.getBoundingClientRect().width + shelfGap;
    };

    const updateShelfControls = () => {
      if (!previousButton || !nextButton) return;
      const maxScroll = shelf.scrollWidth - shelf.clientWidth;
      previousButton.disabled = shelf.scrollLeft <= 2;
      nextButton.disabled = maxScroll <= 2 || shelf.scrollLeft >= maxScroll - 2;
    };

    const scrollShelf = (direction) => {
      const scrollDistance = getScrollDistance();
      if (!scrollDistance) return;
      const reduceMotion = window.matchMedia("(prefers-reduced-motion: reduce)").matches;
      shelf.scrollBy({
        left: direction * scrollDistance,
        behavior: reduceMotion ? "auto" : "smooth"
      });
    };

    previousButton?.addEventListener("click", () => scrollShelf(-1));
    nextButton?.addEventListener("click", () => scrollShelf(1));
    shelf.addEventListener("scroll", () => window.requestAnimationFrame(updateShelfControls), { passive: true });
    window.addEventListener("resize", updateShelfControls);
    updateShelfControls();

    shelf.addEventListener("keydown", (event) => {
      if (event.key !== "ArrowLeft" && event.key !== "ArrowRight") return;

      const firstCard = shelf.querySelector(".rush-product-card");
      if (!firstCard || shelf.scrollWidth <= shelf.clientWidth) return;

      event.preventDefault();
      const scrollDistance = getScrollDistance();
      const reduceMotion = window.matchMedia("(prefers-reduced-motion: reduce)").matches;

      shelf.scrollBy({
        left: (event.key === "ArrowRight" ? 1 : -1) * scrollDistance,
        behavior: reduceMotion ? "auto" : "smooth"
      });
    });
  });

  document.querySelectorAll("[data-quantity]").forEach((quantity) => {
    const input = quantity.querySelector("input");
    const decrease = quantity.querySelector("[data-quantity-decrease]");
    const increase = quantity.querySelector("[data-quantity-increase]");

    if (!input) return;

    decrease?.addEventListener("click", () => {
      const next = Math.max(Number(input.min || 1), Number(input.value || 1) - 1);
      input.value = String(next);
      input.dispatchEvent(new Event("change", { bubbles: true }));
    });

    increase?.addEventListener("click", () => {
      const next = Number(input.value || 1) + 1;
      input.value = String(next);
      input.dispatchEvent(new Event("change", { bubbles: true }));
    });
  });

  const cartForm = document.querySelector(".rush-cart__form");
  const cartQuantityInputs = cartForm?.querySelectorAll("[data-cart-quantity]") || [];
  const cartUpdateStatus = cartForm?.querySelector("[data-cart-update-status]");
  const cartUpdateTimers = new WeakMap();

  document.querySelectorAll("[data-cart-dispatch-date]").forEach((dispatchDate) => {
    const leadTime = Math.max(1, Number(dispatchDate.dataset.businessDays || 1));
    const estimatedDate = new Date();
    estimatedDate.setHours(12, 0, 0, 0);
    let businessDaysRemaining = leadTime;

    while (businessDaysRemaining > 0) {
      estimatedDate.setDate(estimatedDate.getDate() + 1);
      const weekday = estimatedDate.getDay();
      if (weekday !== 0 && weekday !== 6) businessDaysRemaining -= 1;
    }

    const formattedDate = new Intl.DateTimeFormat(undefined, {
      weekday: "long",
      month: "short",
      day: "numeric",
    }).format(estimatedDate);
    dispatchDate.textContent = `Estimated dispatch: ${formattedDate}`;
  });

  document.querySelectorAll("[data-cart-upsell-add]").forEach((button) => {
    button.addEventListener("click", async () => {
      const variantId = button.dataset.cartUpsellAdd;
      if (!variantId || button.disabled) return;

      const originalLabel = button.querySelector("span")?.textContent || "Add to cart";
      button.disabled = true;
      if (button.querySelector("span")) button.querySelector("span").textContent = "Adding…";

      try {
        const root = window.Shopify?.routes?.root || "/";
        const response = await fetch(`${root}cart/add.js`, {
          method: "POST",
          headers: { "Content-Type": "application/json", Accept: "application/json" },
          body: JSON.stringify({ items: [{ id: Number(variantId), quantity: 1 }] })
        });
        if (!response.ok) throw new Error("Add-on failed");
        window.location.reload();
      } catch (error) {
        button.disabled = false;
        if (button.querySelector("span")) button.querySelector("span").textContent = originalLabel;
      }
    });
  });

  const setCartUpdating = (isUpdating, message) => {
    cartForm?.classList.toggle("is-updating", isUpdating);
    cartForm?.querySelectorAll('button[name="checkout"]').forEach((checkoutButton) => {
      checkoutButton.disabled = isUpdating;
    });
    if (cartUpdateStatus) cartUpdateStatus.textContent = message;
  };

  const updateCartLine = async (input) => {
    const lineKey = input.dataset.cartLine;
    const quantity = Math.max(0, Math.floor(Number(input.value) || 0));
    if (!lineKey) return;

    input.value = String(quantity);
    setCartUpdating(true, "Updating cart…");

    try {
      const root = window.Shopify?.routes?.root || "/";
      const response = await fetch(`${root}cart/change.js`, {
        method: "POST",
        headers: { "Content-Type": "application/json", Accept: "application/json" },
        body: JSON.stringify({ id: lineKey, quantity })
      });

      if (!response.ok) throw new Error("Cart update failed");
      window.location.reload();
    } catch (error) {
      setCartUpdating(false, "We couldn't update the cart. Please try again.");
      input.focus();
    }
  };

  cartQuantityInputs.forEach((input) => {
    input.addEventListener("input", () => {
      window.clearTimeout(cartUpdateTimers.get(input));
      setCartUpdating(true, "Updating cart…");
      cartUpdateTimers.set(input, window.setTimeout(() => updateCartLine(input), 500));
    });
    input.addEventListener("change", () => {
      window.clearTimeout(cartUpdateTimers.get(input));
      updateCartLine(input);
    });
  });

  document.querySelectorAll("[data-gallery]").forEach((gallery) => {
    const main = gallery.querySelector("[data-gallery-main]");
    const thumbs = gallery.querySelectorAll("[data-gallery-thumb]");
    const zoomButton = gallery.querySelector("[data-gallery-zoom]");
    const dialog = gallery.querySelector("[data-gallery-dialog]");
    const dialogImage = dialog?.querySelector("[data-gallery-dialog-image]");
    const dialogCaption = dialog?.querySelector("[data-gallery-dialog-caption]");
    const closeButton = dialog?.querySelector("[data-gallery-close]");
    const previousButton = dialog?.querySelector("[data-gallery-previous]");
    const nextButton = dialog?.querySelector("[data-gallery-next]");
    const mainPreviousButton = gallery.querySelector("[data-gallery-main-previous]");
    const mainNextButton = gallery.querySelector("[data-gallery-main-next]");
    const counter = gallery.querySelector("[data-gallery-counter]");

    const selectedThumbIndex = () => Array.from(thumbs).findIndex((item) => item.getAttribute("aria-current") === "true");

    const updateDialogImage = (full, alt) => {
      if (!dialogImage || !full) return;
      dialogImage.src = full;
      dialogImage.alt = alt;
      if (dialogCaption) dialogCaption.textContent = alt;
    };

    const updateCounter = () => {
      if (!counter || !thumbs.length) return;
      counter.textContent = `${Math.max(0, selectedThumbIndex()) + 1} / ${thumbs.length}`;
    };

    const selectThumb = (thumb) => {
      const full = thumb.getAttribute("data-full");
      const mainSource = window.matchMedia("(max-width: 720px)").matches
        ? thumb.getAttribute("data-main-mobile") || thumb.getAttribute("data-main") || full
        : thumb.getAttribute("data-main") || full;
      const alt = thumb.getAttribute("data-alt") || "";
      if (!main || !mainSource) return;

      const currentImage = main.querySelector("img");
      const img = document.createElement("img");
      img.src = mainSource;
      img.alt = alt;
      img.decoding = "async";
      if (currentImage) currentImage.replaceWith(img);
      else main.prepend(img);

      thumbs.forEach((item) => item.setAttribute("aria-current", "false"));
      thumb.setAttribute("aria-current", "true");
      updateDialogImage(full, alt);
      updateCounter();
    };

    const moveGallery = (direction) => {
      if (!thumbs.length) return;
      const currentIndex = Math.max(0, selectedThumbIndex());
      const nextIndex = (currentIndex + direction + thumbs.length) % thumbs.length;
      selectThumb(thumbs[nextIndex]);
    };

    thumbs.forEach((thumb) => {
      thumb.addEventListener("click", () => selectThumb(thumb));
    });

    zoomButton?.addEventListener("click", () => {
      const selectedThumb = thumbs[Math.max(0, selectedThumbIndex())];
      const currentImage = main?.querySelector("img");
      const full = selectedThumb?.getAttribute("data-full") || currentImage?.currentSrc || currentImage?.src;
      const alt = selectedThumb?.getAttribute("data-alt") || currentImage?.alt || "";
      updateDialogImage(full, alt);
      if (typeof dialog?.showModal === "function") dialog.showModal();
      else dialog?.setAttribute("open", "");
      document.body.classList.add("rush-gallery-open");
    });

    closeButton?.addEventListener("click", () => dialog?.close());
    previousButton?.addEventListener("click", () => moveGallery(-1));
    nextButton?.addEventListener("click", () => moveGallery(1));
    mainPreviousButton?.addEventListener("click", () => moveGallery(-1));
    mainNextButton?.addEventListener("click", () => moveGallery(1));

    const addSwipeNavigation = (target) => {
      if (!target || thumbs.length < 2) return;
      let touchStartX = 0;
      let touchStartY = 0;

      target.addEventListener("touchstart", (event) => {
        const touch = event.touches[0];
        if (!touch) return;
        touchStartX = touch.clientX;
        touchStartY = touch.clientY;
      }, { passive: true });

      target.addEventListener("touchend", (event) => {
        const touch = event.changedTouches[0];
        if (!touch) return;
        const horizontalDistance = touch.clientX - touchStartX;
        const verticalDistance = touch.clientY - touchStartY;
        if (Math.abs(horizontalDistance) < 45 || Math.abs(horizontalDistance) <= Math.abs(verticalDistance)) return;
        moveGallery(horizontalDistance > 0 ? -1 : 1);
      }, { passive: true });
    };

    addSwipeNavigation(main);
    addSwipeNavigation(dialog?.querySelector(".rush-gallery-dialog__stage"));
    dialog?.addEventListener("click", (event) => {
      if (event.target === dialog) dialog.close();
    });
    dialog?.addEventListener("keydown", (event) => {
      if (event.key === "ArrowLeft") moveGallery(-1);
      if (event.key === "ArrowRight") moveGallery(1);
      if (event.key === "Escape") {
        event.preventDefault();
        dialog.close();
      }
    });
    dialog?.addEventListener("close", () => document.body.classList.remove("rush-gallery-open"));
    updateCounter();
  });

  document.querySelectorAll("[data-product-form]").forEach((productRoot) => {
    const productForm = productRoot.querySelector("form.rush-product-form");
    const select = productRoot.querySelector("[name='id']");
    const variantOptions = productRoot.querySelectorAll("[data-variant-option]");
    const variantStyleOptions = productRoot.querySelectorAll("[data-variant-style]");
    const compareVariantOptions = productRoot.querySelectorAll("[data-compare-variant]");
    const button = productRoot.querySelector("[data-add-to-cart]");
    const purchaseActions = productRoot.querySelector("[data-purchase-actions]");
    const backInStockForm = productRoot.querySelector("[data-back-in-stock-form]");
    const backInStockVariant = productRoot.querySelector("[data-back-in-stock-variant]");
    const backInStockStatus = productRoot.querySelector("[data-back-in-stock-status]");
    const backInStockSubmit = productRoot.querySelector("[data-back-in-stock-submit]");
    const price = document.querySelector("[data-product-price]");
    const comparePrice = document.querySelector("[data-compare-price]");
    const saving = document.querySelector("[data-product-saving]");
    const productStatus = document.querySelector("[data-product-status]");
    const availability = document.querySelector("[data-product-availability]");
    const dispatchDate = document.querySelector("[data-dispatch-date]");
    const shareBuildButton = document.querySelector("[data-share-build]");
    const shareBuildLabel = shareBuildButton?.querySelector("[data-share-build-label]");
    const shareBuildStatus = document.querySelector("[data-share-build-status]");
    const lowStock = productRoot.querySelector("[data-product-low-stock]");
    const stickyPrice = document.querySelector("[data-sticky-price]");
    const stickyVariant = document.querySelector("[data-sticky-variant]");
    const stickyButton = document.querySelector("[data-sticky-add]");
    const stickyLabel = stickyButton?.querySelector("[data-sticky-add-label]");
    const stickyCart = document.querySelector("[data-sticky-cart]");
    const variantsScript = productRoot.querySelector("[data-variants-json]");
    const inventoryScript = productRoot.querySelector("[data-variant-inventory-json]");
    const configuredTotal = productRoot.querySelector("[data-configured-total]");
    const purchaseVariantLabel = productRoot.querySelector("[data-purchase-variant-label]");
    const cartConfirmation = productRoot.querySelector("[data-cart-confirmation]");
    const cartConfirmationDetail = productRoot.querySelector("[data-cart-confirmation-detail]");
    const cartError = productRoot.querySelector("[data-cart-error]");
    const modPack = productRoot.querySelector("[data-mod-pack]");
    const productMods = document.querySelector("[data-product-mods]");
    const modPackStatus = modPack?.querySelector("[data-mod-pack-status]");
    const modPackKicker = modPack?.querySelector("[data-mod-pack-kicker]");
    const modPackTitle = modPack?.querySelector("[data-mod-pack-title]");
    const modPackCopy = modPack?.querySelector("[data-mod-pack-copy]");
    const modPackBadge = modPack?.querySelector("[data-mod-pack-badge]");
    const modPackProperty = modPack?.querySelector("[data-mod-pack-property]");
    const modPackLiveStatus = modPack?.querySelector("[data-mod-pack-live-status]");
    const selectModdedBuild = modPack?.querySelector("[data-select-modded-build]");
    const modGuide = productRoot.querySelector("[data-mod-guide]");
    const modGuideLabel = modGuide?.querySelector("[data-mod-guide-label]");
    const modGuideKicker = modGuide?.querySelector("[data-mod-guide-kicker]");
    const quantityInput = productForm?.querySelector("[name='quantity']");
    const productGallery = document.querySelector("[data-gallery]");
    const galleryThumbs = productGallery?.querySelectorAll("[data-gallery-thumb]") || [];
    const cartDrawerLayer = document.querySelector("[data-cart-drawer-layer]");
    const cartDrawer = cartDrawerLayer?.querySelector("[data-cart-drawer]");
    const cartDrawerCloseButtons = cartDrawerLayer?.querySelectorAll("[data-cart-drawer-close]") || [];
    const cartDrawerImage = cartDrawerLayer?.querySelector("[data-cart-drawer-image]");
    const cartDrawerQuantity = cartDrawerLayer?.querySelector("[data-cart-drawer-quantity]");
    const cartDrawerVariant = cartDrawerLayer?.querySelector("[data-cart-drawer-variant]");
    const cartDrawerItemTotal = cartDrawerLayer?.querySelector("[data-cart-drawer-item-total]");
    const cartDrawerDispatch = cartDrawerLayer?.querySelector("[data-cart-drawer-dispatch]");
    const cartDrawerCount = cartDrawerLayer?.querySelector("[data-cart-drawer-count]");
    const cartDrawerSubtotal = cartDrawerLayer?.querySelector("[data-cart-drawer-subtotal]");
    if (!select || !variantsScript) return;

    const formatMoney = (cents) => {
      const shopify = window.Shopify || {};
      return shopify.formatMoney
        ? shopify.formatMoney(cents)
        : new Intl.NumberFormat(undefined, { style: "currency", currency: shopify.currency?.active || "USD" }).format(cents / 100);
    };

    const updateDispatchDate = () => {
      if (!dispatchDate) return;
      const leadTime = Math.max(1, Number(dispatchDate.dataset.businessDays || 1));
      const estimatedDate = new Date();
      estimatedDate.setHours(12, 0, 0, 0);
      let businessDaysRemaining = leadTime;

      while (businessDaysRemaining > 0) {
        estimatedDate.setDate(estimatedDate.getDate() + 1);
        const weekday = estimatedDate.getDay();
        if (weekday !== 0 && weekday !== 6) businessDaysRemaining -= 1;
      }

      const formattedDate = new Intl.DateTimeFormat(undefined, {
        weekday: "long",
        month: "short",
        day: "numeric",
      }).format(estimatedDate);
      dispatchDate.textContent = `Estimated dispatch: ${formattedDate}`;
    };

    let variants = [];
    let variantInventory = [];
    try {
      variants = JSON.parse(variantsScript.textContent);
      variantInventory = inventoryScript ? JSON.parse(inventoryScript.textContent) : [];
    } catch (error) {
      return;
    }

    let selectedVariant = null;
    let addToCartResetTimer = null;
    let shareBuildResetTimer = null;
    let cartDrawerCloseTimer = null;
    let cartDrawerReturnFocus = null;

    const describeVariant = (variant) => {
      const title = String(variant?.title || "").toLowerCase();
      const isModded = title.includes("modded") &&
        !title.includes("non-modded") &&
        !title.includes("non modded") &&
        !title.includes("non- modded");
      const hasBack = title.includes("front & back") || title.includes("front and back");
      return {
        group: isModded ? (hasBack ? "front-back-modded" : "front-modded") : (hasBack ? "front-back" : "front"),
        style: title.includes("bullet") ? "bullets" : "standard",
      };
    };

    const selectedArtworkStyle = () =>
      Array.from(variantStyleOptions).find((option) => option.getAttribute("aria-pressed") === "true")?.dataset.variantStyle || "standard";

    const variantForSelection = (group, style) =>
      variants.find((variant) => {
        const descriptor = describeVariant(variant);
        return descriptor.group === group && descriptor.style === style;
      }) || variants.find((variant) => describeVariant(variant).group === group);

    const syncBuildOptionPrices = (style) => {
      const minimumPrice = Math.min(...variants.map((variant) => Number(variant.price || 0)));
      variantOptions.forEach((option) => {
        const variant = variantForSelection(option.dataset.variantGroup, style);
        if (!variant) return;
        option.dataset.variantId = String(variant.id);
        option.classList.toggle("is-sold-out", !variant.available);
        const optionPrice = option.querySelector(".rush-variant-picker__price");
        const optionDifference = option.querySelector(".rush-variant-picker__difference");
        if (optionPrice) optionPrice.textContent = formatMoney(variant.price);
        if (optionDifference) {
          const difference = Number(variant.price || 0) - minimumPrice;
          optionDifference.textContent = difference > 0 ? `+${formatMoney(difference)}` : "Base price";
        }
      });
    };

    const closeCartDrawer = () => {
      if (!cartDrawerLayer || !cartDrawer) return;
      cartDrawerLayer.classList.remove("is-open");
      cartDrawer.setAttribute("aria-hidden", "true");
      document.body.classList.remove("rush-mini-cart-open");
      window.clearTimeout(cartDrawerCloseTimer);
      cartDrawerCloseTimer = window.setTimeout(() => {
        cartDrawerLayer.hidden = true;
        cartDrawerReturnFocus?.focus?.();
      }, 220);
    };

    const openCartDrawer = ({ quantity, cartCount, cartSubtotal }) => {
      if (!cartDrawerLayer || !cartDrawer || !selectedVariant) return;
      const buildName = selectedVariant.title.replace(/\s+design\b/i, "").replace(/\bnon-\s+modded\b/ig, "Non-Modded");
      const currentGalleryImage = productGallery?.querySelector("[data-gallery-main] img");

      if (cartDrawerImage && currentGalleryImage?.src) {
        cartDrawerImage.src = currentGalleryImage.src;
        cartDrawerImage.alt = currentGalleryImage.alt || buildName;
      }
      if (cartDrawerQuantity) cartDrawerQuantity.textContent = `${quantity} ${quantity === 1 ? "controller" : "controllers"}`;
      if (cartDrawerVariant) cartDrawerVariant.textContent = buildName;
      if (cartDrawerItemTotal) cartDrawerItemTotal.textContent = formatMoney(selectedVariant.price * quantity);
      if (cartDrawerCount) cartDrawerCount.textContent = `${cartCount} ${cartCount === 1 ? "item" : "items"} in cart`;
      if (cartDrawerSubtotal) cartDrawerSubtotal.textContent = formatMoney(cartSubtotal);
      if (cartDrawerDispatch && dispatchDate?.textContent) cartDrawerDispatch.textContent = dispatchDate.textContent;

      cartDrawerReturnFocus = document.activeElement;
      window.clearTimeout(cartDrawerCloseTimer);
      cartDrawerLayer.hidden = false;
      cartDrawer.setAttribute("aria-hidden", "false");
      document.body.classList.add("rush-mini-cart-open");
      window.requestAnimationFrame(() => {
        cartDrawerLayer.classList.add("is-open");
        cartDrawer.focus();
      });
    };

    cartDrawerCloseButtons.forEach((closeButton) => closeButton.addEventListener("click", closeCartDrawer));
    cartDrawer?.addEventListener("keydown", (event) => {
      if (event.key === "Escape") {
        event.preventDefault();
        closeCartDrawer();
        return;
      }
      if (event.key !== "Tab") return;

      const focusableElements = Array.from(cartDrawer.querySelectorAll("a[href], button:not([disabled]), [tabindex]:not([tabindex='-1'])"));
      if (!focusableElements.length) return;
      const firstFocusable = focusableElements[0];
      const lastFocusable = focusableElements[focusableElements.length - 1];
      if (event.shiftKey && document.activeElement === firstFocusable) {
        event.preventDefault();
        lastFocusable.focus();
      } else if (!event.shiftKey && document.activeElement === lastFocusable) {
        event.preventDefault();
        firstFocusable.focus();
      }
    });

    const syncVariantMedia = (variant) => {
      const mediaId = variant?.featured_media?.id;
      const imageUrl = variant?.featured_image?.src || variant?.featured_media?.preview_image?.src;
      if (!mediaId && !imageUrl) return;

      const normalizedImageUrl = String(imageUrl || "").replace(/^https?:/, "").split("?")[0];
      const matchingThumb = Array.from(galleryThumbs).find((thumb) => {
        if (mediaId && String(thumb.dataset.mediaId) === String(mediaId)) return true;
        return String(thumb.dataset.full || "").replace(/^https?:/, "").split("?")[0] === normalizedImageUrl;
      });

      if (matchingThumb && matchingThumb.getAttribute("aria-current") !== "true") {
        matchingThumb.click();
      }
    };

    const syncVariantUrl = (variant) => {
      if (!variant?.id || !window.history?.replaceState) return;
      const url = new URL(window.location.href);
      url.searchParams.set("variant", String(variant.id));
      window.history.replaceState({ ...window.history.state, variantId: variant.id }, "", url);
    };

    const updateModState = () => {
      const quantity = Math.max(1, Number(quantityInput?.value || 1));
      const unitTotal = Number(selectedVariant?.price || 0);
      const selectedOption = Array.from(variantOptions).find(
        (option) => String(option.dataset.variantId) === String(selectedVariant?.id)
      );
      const selectedTitle = String(selectedVariant?.title || "").toLowerCase();
      const titleSaysModded = selectedTitle.includes("modded") &&
        !selectedTitle.includes("non-modded") &&
        !selectedTitle.includes("non modded") &&
        !selectedTitle.includes("non- modded");
      const isModdedBuild = selectedOption
        ? selectedOption.dataset.variantModded === "true"
        : titleSaysModded;

      if (configuredTotal) configuredTotal.textContent = formatMoney(unitTotal * quantity);
      if (purchaseVariantLabel && selectedVariant?.title) {
        purchaseVariantLabel.textContent = selectedVariant.title.replace(/\s+design\b/i, "").replace(/\bnon-\s+modded\b/ig, "Non-Modded");
      }
      if (stickyVariant && selectedVariant?.title) {
        stickyVariant.textContent = selectedVariant.title.replace(/\s+design\b/i, "").replace(/\bnon-\s+modded\b/ig, "Non-Modded");
      }
      if (stickyPrice) stickyPrice.textContent = formatMoney(unitTotal);

      if (modPack) {
        modPack.classList.toggle("is-included", isModdedBuild);
        modPack.classList.toggle("is-upgrade", !isModdedBuild);
      }
      if (modPackStatus) {
        modPackStatus.textContent = isModdedBuild ? "Included with this build" : "Available with modded builds";
      }
      if (modPack) modPack.hidden = !isModdedBuild;
      if (productMods) productMods.hidden = !isModdedBuild;
      if (modPackKicker) {
        modPackKicker.textContent = isModdedBuild ? "Complete pack included" : "Upgrade your build";
      }
      if (modPackTitle) {
        modPackTitle.textContent = isModdedBuild
          ? "All programmable features included"
          : "Unlock every feature in the mod guide";
      }
      if (modPackCopy) {
        modPackCopy.textContent = isModdedBuild
          ? "Your selected controller includes the complete Rush performance mod system at no extra charge."
          : "Choose any modded configuration above to include the complete Rush performance mod system.";
      }
      if (modPackBadge) {
        modPackBadge.innerHTML = isModdedBuild
          ? '<span class="material-symbols-outlined" aria-hidden="true">check_circle</span> Included'
          : "Upgrade required";
      }
      if (modPackProperty) {
        modPackProperty.disabled = !isModdedBuild;
      }
      if (selectModdedBuild) {
        selectModdedBuild.hidden = isModdedBuild;
      }

      if (modGuide) {
        modGuide.classList.toggle("is-active", isModdedBuild);
        if (modGuideLabel) {
          modGuideLabel.textContent = isModdedBuild
            ? modGuide.dataset.activeLabel || "View the controller mod guide"
            : modGuide.dataset.inactiveLabel || "Preview the controller mod guide";
        }
        if (modGuideKicker) {
          modGuideKicker.textContent = isModdedBuild ? "Your controls guide" : "See every included feature";
        }
      }

      const label = button?.querySelector("[data-add-to-cart-label]");
      if (label && selectedVariant?.available) {
        label.textContent = window.RushTheme?.strings?.addToCart || "Add to cart";
      }
    };

    const clearBackInStockStatus = () => {
      if (!backInStockStatus) return;
      backInStockStatus.textContent = "";
      backInStockStatus.classList.remove("is-success", "is-error");
    };

    const updateVariant = (updateUrl = false) => {
      const variant = variants.find((item) => String(item.id) === String(select.value));
      if (!variant) return;
      window.clearTimeout(addToCartResetTimer);
      selectedVariant = variant;
      syncVariantMedia(variant);
      if (updateUrl) syncVariantUrl(variant);
      if (modPackLiveStatus) modPackLiveStatus.textContent = "";
      if (cartConfirmation) cartConfirmation.hidden = true;
      if (cartError) cartError.hidden = true;
      window.clearTimeout(shareBuildResetTimer);
      if (shareBuildLabel) shareBuildLabel.textContent = "Share this build";
      if (shareBuildStatus) shareBuildStatus.textContent = "";
      if (shareBuildButton) shareBuildButton.setAttribute("aria-label", `Share ${variant.title.replace(/\s+design\b/i, "").replace(/\bnon-\s+modded\b/ig, "Non-Modded")}`);

      const variantDescriptor = describeVariant(variant);
      syncBuildOptionPrices(variantDescriptor.style);
      variantOptions.forEach((option) => {
        const isSelected = variantStyleOptions.length
          ? option.dataset.variantGroup === variantDescriptor.group
          : String(option.dataset.variantId) === String(variant.id);
        option.classList.toggle("is-selected", isSelected);
        option.setAttribute("aria-pressed", String(isSelected));
      });
      variantStyleOptions.forEach((option) => {
        const isSelected = option.dataset.variantStyle === variantDescriptor.style;
        option.classList.toggle("is-selected", isSelected);
        option.setAttribute("aria-pressed", String(isSelected));
      });
      compareVariantOptions.forEach((option) => {
        const isSelected = String(option.dataset.variantId) === String(variant.id);
        option.classList.toggle("is-selected", isSelected);
        option.setAttribute("aria-pressed", String(isSelected));
      });

      if (button) {
        button.disabled = false;
        const label = button.querySelector("[data-add-to-cart-label]");
        if (label) {
          label.textContent = window.RushTheme?.strings?.addToCart || "Add to cart";
        }
      }

      if (purchaseActions) purchaseActions.hidden = !variant.available;
      if (backInStockForm) backInStockForm.hidden = variant.available;
      if (backInStockVariant) backInStockVariant.value = String(variant.id);
      clearBackInStockStatus();

      if (price && variant.price != null) {
        price.textContent = formatMoney(variant.price);
        if (stickyPrice) stickyPrice.textContent = formatMoney(variant.price);
      }

      if (comparePrice) {
        const isOnSale = Number(variant.compare_at_price || 0) > Number(variant.price || 0);
        comparePrice.hidden = !isOnSale;
        comparePrice.textContent = isOnSale ? formatMoney(variant.compare_at_price) : "";

        if (saving) {
          saving.hidden = !isOnSale;
          saving.textContent = isOnSale
            ? `Save ${Math.round(((variant.compare_at_price - variant.price) / variant.compare_at_price) * 100)}%`
            : "";
        }
      }

      if (lowStock) {
        const inventory = variantInventory.find((item) => String(item.id) === String(variant.id));
        const quantity = Number(inventory?.quantity || 0);
        const threshold = Number(lowStock.dataset.threshold || 5);
        const showLowStock = Boolean(
          variant.available &&
          inventory?.tracked &&
          inventory?.policy === "deny" &&
          quantity > 0 &&
          quantity <= threshold
        );
        lowStock.hidden = !showLowStock;
        const lowStockText = lowStock.querySelector("span:last-child");
        if (lowStockText && showLowStock) {
          lowStockText.textContent = `Only ${quantity} left in this configuration`;
        }
      }

      if (availability) {
        availability.classList.toggle("is-unavailable", !variant.available);
        const availabilityIcons = availability.querySelector(".rush-product__availability-icons");
        const availabilityText = availability.querySelector("[data-product-availability-text]");
        if (availabilityIcons) {
          availabilityIcons.classList.toggle("is-unavailable", !variant.available);
        }
        if (availabilityText) {
          availabilityText.textContent = variant.available
            ? availability.dataset.availableText || "Ships in 1 business day"
            : "This configuration is sold out. Get notified when this exact build returns.";
        }
        if (dispatchDate) dispatchDate.hidden = !variant.available;
      }

      if (productStatus) {
        productStatus.classList.toggle("is-unavailable", !variant.available);
        const productStatusText = productStatus.querySelector("span:last-child");
        if (productStatusText) {
          productStatusText.textContent = variant.available ? "Available to order" : "Currently sold out";
        }
      }

      if (stickyLabel) stickyLabel.textContent = variant.available ? "Add to cart" : "Notify me";
      if (stickyButton) stickyButton.disabled = false;
      if (stickyCart) {
        stickyCart.setAttribute("aria-label", variant.available ? "Quick add to cart" : "Back in stock notification");
      }
      updateModState();
    };

    variantOptions.forEach((option) => {
      option.addEventListener("click", () => {
        const variant = variantStyleOptions.length
          ? variantForSelection(option.dataset.variantGroup, selectedArtworkStyle())
          : variants.find((item) => String(item.id) === String(option.dataset.variantId));
        select.value = variant?.id || option.dataset.variantId || "";
        select.dispatchEvent(new Event("change", { bubbles: true }));
      });
    });

    variantStyleOptions.forEach((option) => {
      option.addEventListener("click", () => {
        const currentGroup = describeVariant(selectedVariant).group;
        const variant = variantForSelection(currentGroup, option.dataset.variantStyle);
        if (!variant) return;
        select.value = String(variant.id);
        select.dispatchEvent(new Event("change", { bubbles: true }));
      });
    });

    compareVariantOptions.forEach((option) => {
      option.addEventListener("click", () => {
        const matchingOption = Array.from(variantOptions).find(
          (variantOption) => String(variantOption.dataset.variantId) === String(option.dataset.variantId)
        );
        if (matchingOption) {
          matchingOption.click();
          return;
        }
        select.value = option.dataset.variantId || "";
        select.dispatchEvent(new Event("change", { bubbles: true }));
      });
    });

    select.addEventListener("change", () => updateVariant(true));
    quantityInput?.addEventListener("change", updateModState);
    selectModdedBuild?.addEventListener("click", () => {
      const availableModdedOption = Array.from(variantOptions).find(
        (option) => option.dataset.variantModded === "true" && !option.classList.contains("is-sold-out")
      );
      const firstModdedOption = availableModdedOption || Array.from(variantOptions).find(
        (option) => option.dataset.variantModded === "true"
      );

      if (!firstModdedOption) {
        if (modPackLiveStatus) modPackLiveStatus.textContent = "A modded build is not available for this controller.";
        return;
      }

      firstModdedOption.click();
      if (modPackLiveStatus) modPackLiveStatus.textContent = "Modded build selected. The complete Performance Mod Pack is included.";
      firstModdedOption.scrollIntoView({ behavior: "smooth", block: "center" });
    });
    updateDispatchDate();
    updateVariant();

    shareBuildButton?.addEventListener("click", async () => {
      if (!selectedVariant) return;
      const productTitle = document.querySelector(".rush-product__info h1, .rush-product__info .rush-h2")?.textContent?.trim() || document.title;
      const buildName = selectedVariant.title.replace(/\s+design\b/i, "").replace(/\bnon-\s+modded\b/ig, "Non-Modded");
      const shareData = {
        title: productTitle,
        text: `${productTitle} — ${buildName}`,
        url: window.location.href,
      };

      window.clearTimeout(shareBuildResetTimer);
      try {
        if (navigator.share && window.matchMedia("(pointer: coarse)").matches) {
          await navigator.share(shareData);
          if (shareBuildLabel) shareBuildLabel.textContent = "Shared";
          if (shareBuildStatus) shareBuildStatus.textContent = "Build shared.";
        } else {
          if (navigator.clipboard?.writeText) {
            await navigator.clipboard.writeText(shareData.url);
          } else {
            const temporaryInput = document.createElement("textarea");
            temporaryInput.value = shareData.url;
            temporaryInput.setAttribute("readonly", "");
            temporaryInput.style.position = "fixed";
            temporaryInput.style.opacity = "0";
            document.body.append(temporaryInput);
            temporaryInput.select();
            document.execCommand("copy");
            temporaryInput.remove();
          }
          if (shareBuildLabel) shareBuildLabel.textContent = "Link copied";
          if (shareBuildStatus) shareBuildStatus.textContent = "Exact build link copied to clipboard.";
        }

        shareBuildResetTimer = window.setTimeout(() => {
          if (shareBuildLabel) shareBuildLabel.textContent = "Share this build";
        }, 2400);
      } catch (error) {
        if (error.name === "AbortError") return;
        if (shareBuildLabel) shareBuildLabel.textContent = "Try again";
        if (shareBuildStatus) shareBuildStatus.textContent = "The build link could not be shared.";
      }
    });

    productForm?.addEventListener("submit", async (event) => {
      if (event.submitter && event.submitter !== button) return;
      if (!button || !selectedVariant?.available) return;
      event.preventDefault();

      const label = button.querySelector("[data-add-to-cart-label]");
      const quantity = Math.max(1, Number(quantityInput?.value || 1));
      const cartLink = document.querySelector(".rush-cart-link");
      const existingCartCount = cartLink?.querySelector(".rush-cart-count");
      const previousCartCount = Number(existingCartCount?.textContent || 0);

      window.clearTimeout(addToCartResetTimer);
      button.disabled = true;
      if (label) label.textContent = "Adding…";
      if (stickyButton) stickyButton.disabled = true;
      if (stickyLabel) stickyLabel.textContent = "Adding…";
      if (cartConfirmation) cartConfirmation.hidden = true;
      if (cartError) cartError.hidden = true;

      try {
        const response = await fetch(`${window.RushTheme?.routes?.cartAdd || "/cart/add"}.js`, {
          method: "POST",
          headers: { Accept: "application/json" },
          body: new FormData(productForm),
        });
        const result = await response.json().catch(() => ({}));
        if (!response.ok) throw new Error(result.description || "This build could not be added to your cart.");

        let cartCount = previousCartCount + quantity;
        let cartSubtotal = selectedVariant.price * quantity;
        try {
          const cartResponse = await fetch(`${window.RushTheme?.routes?.cart || "/cart"}.js`, {
            headers: { Accept: "application/json" },
          });
          if (cartResponse.ok) {
            const cart = await cartResponse.json();
            cartCount = Number(cart.item_count || cartCount);
            cartSubtotal = Number(cart.total_price || cartSubtotal);
          }
        } catch (error) {
          // The item was added successfully; the optimistic count remains valid.
        }

        if (cartLink) {
          const cartCountElement = existingCartCount || document.createElement("span");
          cartCountElement.className = "rush-cart-count";
          cartCountElement.textContent = String(cartCount);
          if (!existingCartCount) cartLink.append(cartCountElement);
        }

        if (cartConfirmationDetail) {
          const buildName = selectedVariant.title.replace(/\s+design\b/i, "").replace(/\bnon-\s+modded\b/ig, "Non-Modded");
          cartConfirmationDetail.textContent = `${quantity} × ${buildName}`;
        }
        if (cartConfirmation) cartConfirmation.hidden = false;
        if (label) label.textContent = "Added to cart";
        if (stickyLabel) stickyLabel.textContent = "Added";
        openCartDrawer({ quantity, cartCount, cartSubtotal });

        addToCartResetTimer = window.setTimeout(() => {
          if (label) label.textContent = window.RushTheme?.strings?.addToCart || "Add to cart";
          if (stickyLabel) stickyLabel.textContent = "Add to cart";
          if (stickyButton) stickyButton.disabled = false;
        }, 2200);
      } catch (error) {
        if (cartError) {
          cartError.textContent = error.message || "This build could not be added. Please try again.";
          cartError.hidden = false;
        }
        if (label) label.textContent = window.RushTheme?.strings?.addToCart || "Add to cart";
        if (stickyLabel) stickyLabel.textContent = "Try again";
        if (stickyButton) stickyButton.disabled = false;
      } finally {
        button.disabled = false;
      }
    });

    backInStockForm?.addEventListener("submit", async (event) => {
      event.preventDefault();
      if (!selectedVariant || selectedVariant.available || !backInStockStatus || !backInStockSubmit) return;

      const emailInput = backInStockForm.querySelector("[name='email']");
      const companyId = backInStockForm.dataset.klaviyoCompanyId?.trim();
      if (!emailInput?.reportValidity()) return;

      clearBackInStockStatus();

      if (!companyId) {
        backInStockStatus.textContent = "Notifications are not configured yet. Please contact us for help.";
        backInStockStatus.classList.add("is-error");
        return;
      }

      const originalLabel = backInStockSubmit.textContent;
      backInStockSubmit.disabled = true;
      backInStockSubmit.textContent = "Joining…";

      const payload = {
        data: {
          type: "back-in-stock-subscription",
          attributes: {
            profile: {
              data: {
                type: "profile",
                attributes: { email: emailInput.value.trim() },
              },
            },
            channels: ["EMAIL"],
          },
          relationships: {
            variant: {
              data: {
                type: "catalog-variant",
                id: `$shopify:::$default:::${selectedVariant.id}`,
              },
            },
          },
        },
      };

      try {
        const response = await fetch(`https://a.klaviyo.com/client/back-in-stock-subscriptions/?company_id=${encodeURIComponent(companyId)}`, {
          method: "POST",
          headers: {
            "Content-Type": "application/json",
            revision: "2026-07-15",
          },
          body: JSON.stringify(payload),
        });

        if (!response.ok) throw new Error(`Klaviyo returned ${response.status}`);

        backInStockStatus.textContent = "You're on the list. We'll email you when this build is back.";
        backInStockStatus.classList.add("is-success");
        emailInput.value = "";
      } catch (error) {
        backInStockStatus.textContent = "We couldn't save your request. Please try again.";
        backInStockStatus.classList.add("is-error");
      } finally {
        backInStockSubmit.disabled = false;
        backInStockSubmit.textContent = originalLabel;
      }
    });

    stickyButton?.addEventListener("click", () => {
      if (selectedVariant?.available) {
        button?.click();
        return;
      }

      backInStockForm?.scrollIntoView({ behavior: "smooth", block: "center" });
      window.setTimeout(() => backInStockForm?.querySelector("[name='email']")?.focus(), 350);
    });
  });

  const stickyCart = document.querySelector("[data-sticky-cart]");
  const primaryProductForm = document.querySelector("[data-product-form]");
  const stickyCartAction = stickyCart?.querySelector("[data-sticky-add]");
  const getStickyTrigger = () => primaryProductForm?.querySelector(
    "[data-purchase-actions]:not([hidden]) [data-add-to-cart], " +
    "[data-back-in-stock-form]:not([hidden]) [data-back-in-stock-submit]"
  );
  if (stickyCart && primaryProductForm) {
    let stickyUpdateQueued = false;
    const updateStickyCart = () => {
      const stickyTrigger = getStickyTrigger();
      const triggerRect = stickyTrigger?.getBoundingClientRect();
      const triggerIsVisible = Boolean(
        triggerRect && triggerRect.bottom > 0 && triggerRect.top < window.innerHeight
      );
      const showStickyCart = Boolean(stickyTrigger && !triggerIsVisible);

      stickyCart.classList.toggle("is-visible", showStickyCart);
      stickyCart.setAttribute("aria-hidden", String(!showStickyCart));
      if (stickyCartAction) stickyCartAction.tabIndex = showStickyCart ? 0 : -1;
      stickyUpdateQueued = false;
    };
    const queueStickyCartUpdate = () => {
      if (stickyUpdateQueued) return;
      stickyUpdateQueued = true;
      window.requestAnimationFrame(updateStickyCart);
    };
    window.addEventListener("scroll", queueStickyCartUpdate, { passive: true });
    window.addEventListener("resize", queueStickyCartUpdate);
    new MutationObserver(queueStickyCartUpdate).observe(primaryProductForm, {
      attributes: true,
      attributeFilter: ["hidden"],
      subtree: true,
    });
    updateStickyCart();
  }

  document.querySelectorAll("[data-scroll-target]").forEach((button) => {
    button.addEventListener("click", () => {
      const target = document.querySelector(button.getAttribute("data-scroll-target"));
      target?.scrollIntoView({ behavior: "smooth", block: "start" });
    });
  });

  // Shopify recommendations render through a section endpoint so the same
  // Liquid product-card component is used on product pages and in the editor.
  document.querySelectorAll("[data-product-recommendations]").forEach(async (section) => {
    if (!section.dataset.url || section.dataset.loaded === "true") return;

    try {
      const response = await fetch(section.dataset.url);
      if (!response.ok) {
        console.warn(`Product recommendations request failed with ${response.status}.`);
        return;
      }
      const html = new DOMParser().parseFromString(await response.text(), "text/html");
      const replacement = html.querySelector("[data-product-recommendations]");
      if (!replacement || !replacement.querySelector(".rush-product-card")) {
        console.warn("Product recommendations returned no products and no fallback products were available.");
        return;
      }
      replacement.dataset.loaded = "true";
      section.replaceWith(replacement);
    } catch (error) {
      // Recommendations are an enhancement; the core product page stays usable.
    }
  });

  // Shopify caps a section at 50 blocks. Additional review-bank sections stay
  // hidden on the Reviews page, while their cards are merged into the primary
  // grid so the storefront behaves like one review library.
  const reviewLibrary = document.querySelector("[data-review-library-primary]");
  if (reviewLibrary && !reviewLibrary.dataset.reviewLibraryReady) {
    const reviewGrid = reviewLibrary.querySelector("[data-review-grid]");
    const bankReviews = document.querySelectorAll("[data-review-bank] [data-editor-review]");

    bankReviews.forEach((review) => {
      const clonedReview = review.cloneNode(true);
      clonedReview.removeAttribute("data-shopify-editor-block");
      reviewGrid?.appendChild(clonedReview);
      clonedReview.querySelectorAll("video").forEach((video) => video.load());
    });

    const combinedReviews = Array.from(reviewGrid?.querySelectorAll("[data-editor-review]") || []);
    if (combinedReviews.length) {
      const ratings = combinedReviews.map((review) => Number(review.dataset.rating || 0));
      const ratingTotal = ratings.reduce((total, rating) => total + rating, 0);
      const averageRating = ratingTotal / ratings.length;
      const average = reviewLibrary.querySelector("[data-review-library-average]");
      const count = reviewLibrary.querySelector("[data-review-library-count]");
      const stars = reviewLibrary.querySelectorAll("[data-review-library-stars] > span");
      const allFilter = reviewLibrary.querySelector("[data-review-library-all]");

      if (average) average.textContent = averageRating.toFixed(1);
      if (count) count.textContent = `${combinedReviews.length} reviews total`;
      if (allFilter) allFilter.textContent = `All (${combinedReviews.length})`;
      stars.forEach((star, index) => star.classList.toggle("is-empty", index + 1 > Math.round(averageRating)));

      reviewLibrary.querySelectorAll("[data-review-library-bar]").forEach((bar) => {
        const rating = Number(bar.dataset.reviewLibraryBar || 0);
        const ratingCount = ratings.filter((value) => value === rating).length;
        const fill = bar.querySelector("[data-review-library-bar-fill]");
        const barCount = bar.querySelector("[data-review-library-bar-count]");
        if (fill) fill.style.width = `${(ratingCount / ratings.length) * 100}%`;
        if (barCount) barCount.textContent = String(ratingCount);
      });

      reviewLibrary.querySelectorAll("[data-review-filter]:not([data-review-filter='all'])").forEach((button) => {
        const rating = Number(button.dataset.reviewFilter || 0);
        const ratingCount = ratings.filter((value) => value === rating).length;
        button.textContent = `${rating} ★ (${ratingCount})`;
      });
    }

    reviewLibrary.dataset.reviewLibraryReady = "true";
  }

  if (reviewLibrary && !reviewLibrary.dataset.reviewBatchReady) {
    const reviewGrid = reviewLibrary.querySelector("[data-review-grid]");
    const filterButtons = reviewLibrary.querySelectorAll("[data-review-filter]");
    const loadMoreWrap = reviewLibrary.querySelector("[data-review-load-more-wrap]");
    const loadMoreButton = reviewLibrary.querySelector("[data-review-load-more]");
    const loadMoreLabel = reviewLibrary.querySelector("[data-review-load-more-label]");
    const loadMoreStatus = reviewLibrary.querySelector("[data-review-load-more-status]");
    const noResults = reviewLibrary.querySelector("[data-review-no-results]");
    const pageSize = Math.max(1, Number(reviewLibrary.dataset.reviewPageSize || 25));
    let activeFilter = "all";
    let visibleLimit = pageSize;

    const renderReviewBatch = () => {
      const cards = Array.from(reviewGrid?.querySelectorAll("[data-review-card]") || []);
      const matchingCards = cards.filter((card) => activeFilter === "all" || card.dataset.rating === activeFilter);

      cards.forEach((card) => {
        const matchingIndex = matchingCards.indexOf(card);
        card.hidden = matchingIndex === -1 || matchingIndex >= visibleLimit;
      });

      const visibleCount = Math.min(visibleLimit, matchingCards.length);
      const remainingCount = Math.max(0, matchingCards.length - visibleCount);
      const filterDescription = activeFilter === "all" ? "reviews" : `${activeFilter}-star reviews`;

      if (loadMoreStatus) loadMoreStatus.textContent = `Showing ${visibleCount} of ${matchingCards.length} ${filterDescription}`;
      if (loadMoreLabel) loadMoreLabel.textContent = remainingCount > pageSize
        ? `Show ${pageSize} more reviews`
        : `Show ${remainingCount} more ${remainingCount === 1 ? "review" : "reviews"}`;
      if (loadMoreWrap) loadMoreWrap.hidden = remainingCount === 0;
      if (noResults) noResults.hidden = matchingCards.length !== 0;
    };

    filterButtons.forEach((button) => {
      button.addEventListener("click", () => {
        activeFilter = button.dataset.reviewFilter || "all";
        visibleLimit = pageSize;
        filterButtons.forEach((filterButton) => {
          const isActive = filterButton === button;
          filterButton.classList.toggle("is-active", isActive);
          filterButton.setAttribute("aria-pressed", String(isActive));
        });
        renderReviewBatch();
      });
    });

    loadMoreButton?.addEventListener("click", () => {
      visibleLimit += pageSize;
      renderReviewBatch();
    });

    renderReviewBatch();
    reviewLibrary.dataset.reviewBatchReady = "true";
  }

  // Theme-editor review blocks live on the Reviews page template. Shopify does
  // not expose one template's blocks to another in Liquid, so product pages
  // read the rendered Reviews page and display blocks assigned to this product.
  document.querySelectorAll("[data-home-review-grid]").forEach(async (reviewGrid) => {
    const reviewsUrl = reviewGrid.dataset.reviewsUrl;
    const reviewLimit = Math.min(Number.parseInt(reviewGrid.dataset.reviewLimit || "3", 10), 5);
    if (!reviewsUrl) return;

    try {
      const reviewsRequestUrl = new URL(reviewsUrl, window.location.origin);
      const currentParams = new URLSearchParams(window.location.search);
      ["preview_theme_id", "_fd", "pb"].forEach((parameter) => {
        if (currentParams.has(parameter)) reviewsRequestUrl.searchParams.set(parameter, currentParams.get(parameter));
      });

      const response = await fetch(reviewsRequestUrl, { credentials: "same-origin" });
      if (!response.ok) return;

      const reviewPage = new DOMParser().parseFromString(await response.text(), "text/html");
      const pageReviews = Array.from(reviewPage.querySelectorAll("[data-editor-review]"));
      if (!pageReviews.length) return;

      const highlightExclusions = /\b(batter(?:y|ies)|issue(?:s)?|problem(?:s)?|sucks|pricey|wrong|concern(?:s)?|refund|return)\b/i;
      const strongReviews = pageReviews.filter((review) => {
        const rating = Number(review.dataset.rating || 0);
        return rating >= 5 && !highlightExclusions.test(review.textContent || "");
      });
      const reviewsForHighlights = strongReviews.length >= reviewLimit ? strongReviews : pageReviews;
      const highlightReviews = reviewsForHighlights.slice(0, reviewLimit).map((review) => {
        const clonedReview = review.cloneNode(true);
        const title = clonedReview.querySelector("h3");
        if (title && /^amazing controller$/i.test(title.textContent.trim())) title.remove();
        return clonedReview;
      });

      reviewGrid.replaceChildren(...highlightReviews);
    } catch (_error) {
      // Server-rendered homepage reviews remain visible if synchronization fails.
    }
  });

  document.querySelectorAll("[data-editor-product-reviews]").forEach(async (editorReviews) => {
    const productId = editorReviews.dataset.productId;
    const reviewsUrl = editorReviews.dataset.reviewsUrl;
    const reviewLimit = Number(editorReviews.dataset.reviewLimit || 4);
    const useUnassignedReviews = editorReviews.dataset.useUnassignedReviews === "true";
    if (!productId || !reviewsUrl) return;

    try {
      const reviewsRequestUrl = new URL(reviewsUrl, window.location.origin);
      const currentParams = new URLSearchParams(window.location.search);
      ["preview_theme_id", "_fd", "pb"].forEach((parameter) => {
        if (currentParams.has(parameter)) reviewsRequestUrl.searchParams.set(parameter, currentParams.get(parameter));
      });
      const response = await fetch(reviewsRequestUrl, { credentials: "same-origin" });
      if (!response.ok) return;

      const reviewPage = new DOMParser().parseFromString(await response.text(), "text/html");
      const reviewPageEntries = Array.from(reviewPage.querySelectorAll("[data-editor-review]"));
      const productReviews = reviewPageEntries.filter((review) => review.dataset.productId === productId);
      const unassignedReviews = reviewPageEntries.filter((review) => !review.dataset.productId);
      const matchingReviews = productReviews.length
        ? productReviews
        : (useUnassignedReviews ? unassignedReviews : []);
      if (!matchingReviews.length) return;

      const ratingTotal = matchingReviews.reduce((total, review) => total + Number(review.dataset.rating || 0), 0);
      const averageRating = ratingTotal / matchingReviews.length;
      const reviewGrid = editorReviews.querySelector("[data-editor-review-grid]");
      const average = editorReviews.querySelector("[data-editor-review-average]");
      const count = editorReviews.querySelector("[data-editor-review-count]");
      const stars = editorReviews.querySelectorAll("[data-editor-review-stars] > span");
      const headerScore = editorReviews.parentElement?.querySelector("[data-editor-header-score]");
      const headerAverage = headerScore?.querySelector("[data-editor-header-average]");
      const headerCount = headerScore?.querySelector("[data-editor-header-count]");
      const headerStars = headerScore?.querySelectorAll("[data-editor-header-stars] > span") || [];

      matchingReviews.slice(0, reviewLimit).forEach((review) => {
        const clonedReview = review.cloneNode(true);
        clonedReview.removeAttribute("data-shopify-editor-block");
        clonedReview.classList.add("rush-review-card--compact");
        reviewGrid?.appendChild(clonedReview);
        clonedReview.querySelectorAll("video").forEach((video) => video.load());
      });

      if (average) average.textContent = averageRating.toFixed(1);
      if (count) count.textContent = `Based on ${matchingReviews.length} customer ${matchingReviews.length === 1 ? "review" : "reviews"}`;
      stars.forEach((star, index) => star.classList.toggle("is-empty", index + 1 > Math.round(averageRating)));
      if (headerAverage) headerAverage.textContent = averageRating.toFixed(1);
      if (headerCount) headerCount.textContent = `${matchingReviews.length} customer ${matchingReviews.length === 1 ? "review" : "reviews"}`;
      headerStars.forEach((star, index) => star.classList.toggle("is-empty", index + 1 > Math.round(averageRating)));
      headerScore?.setAttribute("aria-label", `Rated ${averageRating.toFixed(1)} out of 5 from ${matchingReviews.length} customer ${matchingReviews.length === 1 ? "review" : "reviews"}`);

      const serverReviews = editorReviews.parentElement?.querySelector("[data-server-product-reviews]");
      if (serverReviews) serverReviews.hidden = true;
      editorReviews.hidden = false;
    } catch (error) {
      // The server-rendered product review state remains available as fallback.
    }
  });

  document.querySelectorAll("[data-product-review-section]").forEach((section) => {
    const filterButtons = section.querySelectorAll("[data-review-filter]");
    const reviewCards = section.querySelectorAll("[data-review-card]");
    const status = section.querySelector("[data-review-filter-status]");
    const noResults = section.querySelector("[data-review-no-results]");
    const totalReviewCount = Number(section.dataset.reviewTotal || reviewCards.length);

    filterButtons.forEach((button) => {
      button.addEventListener("click", () => {
        const selectedRating = button.dataset.reviewFilter;
        let visibleCount = 0;

        filterButtons.forEach((filterButton) => {
          const isActive = filterButton === button;
          filterButton.classList.toggle("is-active", isActive);
          filterButton.setAttribute("aria-pressed", String(isActive));
        });

        reviewCards.forEach((card) => {
          const isVisible = selectedRating === "all" || card.dataset.rating === selectedRating;
          card.hidden = !isVisible;
          if (isVisible) visibleCount += 1;
        });

        if (status) {
          status.textContent = selectedRating === "all"
            ? `Showing ${visibleCount} of ${totalReviewCount} reviews`
            : `Showing ${visibleCount} featured ${selectedRating}-star ${visibleCount === 1 ? "review" : "reviews"}`;
        }
        if (noResults) noResults.hidden = visibleCount !== 0;
      });
    });
  });

  // ─── Scroll animations ───────────────────────────────────────────────────────

  const RUSH_ANIM_CSS = `
    .rush-reveal {
      opacity: 0;
      transform: translateY(22px);
      transition: opacity 0.55s cubic-bezier(0.22, 1, 0.36, 1),
                  transform 0.55s cubic-bezier(0.22, 1, 0.36, 1);
      will-change: opacity, transform;
    }
    .rush-reveal.rush-reveal--left {
      transform: translateX(-28px);
    }
    .rush-reveal.rush-reveal--right {
      transform: translateX(28px);
    }
    .rush-reveal.rush-reveal--scale {
      transform: translateY(14px) scale(0.96);
    }
    .rush-reveal.is-visible {
      opacity: 1;
      transform: none;
    }
    @media (prefers-reduced-motion: reduce) {
      .rush-reveal {
        opacity: 1;
        transform: none;
        transition: none;
      }
    }
  `;

  // Inject animation styles once
  const rushStyleTag = document.createElement("style");
  rushStyleTag.textContent = RUSH_ANIM_CSS;
  document.head.appendChild(rushStyleTag);

  // Elements to animate — mapped to their variant and stagger behaviour
  const RUSH_SELECTORS = [
    // Hero content fades up immediately
    { selector: ".rush-hero__content",        variant: "",        stagger: false },
    { selector: ".rush-cinch-hero__content",  variant: "",        stagger: false },
    { selector: ".rush-lab-hero__content",    variant: "",        stagger: false },

    // Section headers slide up
    { selector: ".rush-section-header",       variant: "",        stagger: false },
    { selector: ".rush-section-header--center", variant: "",      stagger: false },

    // Product cards stagger in
    { selector: ".rush-product-card",         variant: "scale",   stagger: true  },
    { selector: ".rush-blueprint-card",       variant: "scale",   stagger: true  },
    { selector: ".rush-category-tile",        variant: "scale",   stagger: true  },
    { selector: ".rush-customizer-card",      variant: "scale",   stagger: true  },
    { selector: ".rush-community-logo",       variant: "scale",   stagger: true  },
    { selector: ".rush-feature-panel",        variant: "scale",   stagger: true  },
    { selector: ".rush-shop-category__item",  variant: "scale",   stagger: true  },

    // Trust stats count up — stagger
    { selector: ".rush-trust-stat",           variant: "",        stagger: true  },
    { selector: ".rush-step",                 variant: "",        stagger: true  },
    { selector: ".rush-cinch-proof > div",    variant: "",        stagger: true  },

    // Story split — left/right slide
    { selector: ".rush-story__grid > :first-child",   variant: "left",  stagger: false },
    { selector: ".rush-story__grid > :last-child",    variant: "right", stagger: false },

    // Contact grid — left/right slide
    { selector: ".rush-contact__brief",       variant: "left",    stagger: false },
    { selector: ".rush-contact__panel",       variant: "right",   stagger: false },

    // Lab control — left/right
    { selector: ".rush-control__grid > :first-child", variant: "left",  stagger: false },
    { selector: ".rush-control__grid > :last-child",  variant: "right", stagger: false },

    // Newsletter box
    { selector: ".rush-newsletter",           variant: "scale",   stagger: false },

    // Spec cards
    { selector: ".rush-spec-card",            variant: "scale",   stagger: true  },

    // Quick-ship scroller
    { selector: ".rush-product-scroller",     variant: "",        stagger: false },
  ];

  // Reduce motion preference
  const prefersReducedMotion =
    window.matchMedia("(prefers-reduced-motion: reduce)").matches ||
    Boolean(window.Shopify?.designMode);

  if (!prefersReducedMotion) {
    // Assign .rush-reveal classes and stagger delays
    RUSH_SELECTORS.forEach(({ selector, variant, stagger }) => {
      const elements = document.querySelectorAll(selector);
      elements.forEach((el, i) => {
        // Skip elements already inside another reveal (avoid double-animating)
        if (el.closest(".rush-reveal")) return;

        el.classList.add("rush-reveal");
        if (variant) el.classList.add(`rush-reveal--${variant}`);

        if (stagger && i > 0) {
          // Cap stagger at 5 items to avoid long waits
          el.style.transitionDelay = `${Math.min(i, 5) * 80}ms`;
        }
      });
    });

    // Single IntersectionObserver for all animated elements
    const rushObserver = new IntersectionObserver(
      (entries) => {
        entries.forEach((entry) => {
          if (entry.isIntersecting) {
            entry.target.classList.add("is-visible");
            rushObserver.unobserve(entry.target); // animate once only
          }
        });
      },
      {
        threshold: 0.12,      // trigger when 12% of element is visible
        rootMargin: "0px 0px -40px 0px", // slight offset so elements don't pop in at the very edge
      }
    );

    document.querySelectorAll(".rush-reveal").forEach((el) => rushObserver.observe(el));
  }

  // ─── Stat counter animation ──────────────────────────────────────────────────
  // Animates numbers like "10,000+" counting up when they scroll into view

  function rushAnimateCounter(el) {
    const raw = el.textContent.trim();
    // Extract numeric portion and suffix (e.g. "10,000+" → num: 10000, suffix: "+")
    const match = raw.match(/^([0-9,]+\.?[0-9]*)(.*)$/);
    if (!match) return;

    const target = parseFloat(match[1].replace(/,/g, ""));
    const suffix = match[2] || "";
    const isFloat = match[1].includes(".");
    const decimals = isFloat ? (match[1].split(".")[1] || "").length : 0;
    const duration = 1200; // ms
    const start = performance.now();

    function tick(now) {
      const elapsed = now - start;
      const progress = Math.min(elapsed / duration, 1);
      // Ease out cubic
      const eased = 1 - Math.pow(1 - progress, 3);
      const current = target * eased;

      if (decimals > 0) {
        el.textContent = current.toFixed(decimals) + suffix;
      } else if (target >= 1000) {
        el.textContent = Math.round(current).toLocaleString() + suffix;
      } else {
        el.textContent = Math.round(current) + suffix;
      }

      if (progress < 1) requestAnimationFrame(tick);
    }

    requestAnimationFrame(tick);
  }

  // Observe stat number elements
  const counterObserver = new IntersectionObserver(
    (entries) => {
      entries.forEach((entry) => {
        if (entry.isIntersecting) {
          rushAnimateCounter(entry.target);
          counterObserver.unobserve(entry.target);
        }
      });
    },
    { threshold: 0.5 }
  );

  document.querySelectorAll(".rush-trust-stat span").forEach((el) => {
    // Only animate elements that contain a leading number
    if (/^[0-9]/.test(el.textContent.trim())) {
      counterObserver.observe(el);
    }
  });

  document.querySelectorAll("[data-mod-guides]").forEach((guide) => {
    const platformButtons = Array.from(guide.querySelectorAll("[data-guide-platform]"));
    const platformPanels = Array.from(guide.querySelectorAll("[data-guide-panel]"));
    const categoryLinks = Array.from(guide.querySelectorAll(".rush-mod-guide__categories a"));

    const selectPlatform = (platform, updateUrl = true) => {
      const selectedPlatform = platform === "xbox" ? "xbox" : "playstation";

      platformButtons.forEach((button) => {
        const active = button.dataset.guidePlatform === selectedPlatform;
        button.classList.toggle("is-active", active);
        button.setAttribute("aria-selected", String(active));
        button.tabIndex = active ? 0 : -1;
      });

      platformPanels.forEach((panel) => {
        const active = panel.dataset.guidePanel === selectedPlatform;
        panel.hidden = !active;
        panel.classList.toggle("is-active", active);
      });

      if (updateUrl) {
        const url = new URL(window.location.href);
        url.searchParams.set("platform", selectedPlatform);
        window.history.replaceState({}, "", url);
      }
    };

    platformButtons.forEach((button, index) => {
      button.addEventListener("click", () => selectPlatform(button.dataset.guidePlatform));
      button.addEventListener("keydown", (event) => {
        if (!['ArrowLeft', 'ArrowRight'].includes(event.key)) return;
        event.preventDefault();
        const direction = event.key === 'ArrowRight' ? 1 : -1;
        const nextIndex = (index + direction + platformButtons.length) % platformButtons.length;
        platformButtons[nextIndex].focus();
        platformButtons[nextIndex].click();
      });
    });

    categoryLinks.forEach((link) => {
      link.addEventListener("click", (event) => {
        event.preventDefault();
        categoryLinks.forEach((item) => item.classList.toggle("is-active", item === link));
        const activePanel = platformPanels.find((panel) => !panel.hidden);
        const target = activePanel?.querySelector(`[data-guide-anchor="${link.dataset.guideSection}"]`);
        target?.scrollIntoView({ behavior: "smooth", block: "start" });
      });
    });

    guide.querySelectorAll(".rush-mod-guide__modes details").forEach((details) => {
      details.addEventListener("toggle", () => {
        if (!details.open) return;
        details.parentElement?.querySelectorAll("details[open]").forEach((other) => {
          if (other !== details) other.open = false;
        });
      });
    });

    const requestedPlatform = new URLSearchParams(window.location.search).get("platform");
    selectPlatform(requestedPlatform, false);
  });

  // First-purchase promotion: delayed display, accessible dismissal, and cooldown.
  document.querySelectorAll("[data-rush-promo]").forEach((promo) => {
    const storageKey = "rush_promo_dismissed_at";
    const closeButtons = promo.querySelectorAll("[data-rush-promo-close]");
    const success = promo.querySelector("[data-rush-promo-success]");
    const codeButton = promo.querySelector("[data-rush-promo-code]");
    const discountUrl = promo.dataset.discountUrl;
    const frequencyMs = Math.max(1, Number(promo.dataset.frequencyDays || 7)) * 86400000;
    const delay = Math.max(0, Number(promo.dataset.delay || 0));
    let opener = null;

    const rememberDismissal = (duration = frequencyMs) => {
      try {
        localStorage.setItem(storageKey, String(Date.now() + duration));
      } catch (error) {
        // Storage can be unavailable in strict privacy modes; dismissal still works.
      }
    };

    const isSuppressed = () => {
      if (window.Shopify?.designMode) return false;
      try {
        return Number(localStorage.getItem(storageKey) || 0) > Date.now();
      } catch (error) {
        return false;
      }
    };

    const openPromo = () => {
      if (promo.open || isSuppressed()) return;
      opener = document.activeElement;
      if (typeof promo.showModal === "function") promo.showModal();
      else promo.setAttribute("open", "");
      document.body.classList.add("rush-promo-open");
      window.dataLayer = window.dataLayer || [];
      window.dataLayer.push({ event: "rush_promo_view", promo_name: "first_purchase_15_off" });
    };

    const closePromo = (remember = true) => {
      if (!promo.open) return;
      if (remember) rememberDismissal();
      if (typeof promo.close === "function") promo.close();
      else promo.removeAttribute("open");
      document.body.classList.remove("rush-promo-open");
      if (opener instanceof HTMLElement) opener.focus({ preventScroll: true });
    };

    closeButtons.forEach((button) => button.addEventListener("click", () => closePromo(true)));
    promo.addEventListener("cancel", (event) => {
      event.preventDefault();
      closePromo(true);
    });
    promo.addEventListener("click", (event) => {
      if (event.target === promo) closePromo(true);
    });
    promo.addEventListener("close", () => document.body.classList.remove("rush-promo-open"));

    codeButton?.addEventListener("click", async () => {
      const code = codeButton.dataset.rushPromoCode || "";
      if (!code) return;
      try {
        await navigator.clipboard.writeText(code);
        codeButton.classList.add("is-copied");
        const label = codeButton.querySelector("small");
        if (label) label.textContent = "Copied";
      } catch (error) {
        const range = document.createRange();
        range.selectNodeContents(codeButton.querySelector("span"));
        const selection = window.getSelection();
        selection.removeAllRanges();
        selection.addRange(range);
      }
    });

    if (success) {
      rememberDismissal(30 * 86400000);
      if (discountUrl) {
        fetch(discountUrl, { credentials: "same-origin", redirect: "follow" }).catch(() => {});
      }
      openPromo();
      window.requestAnimationFrame(() => success.focus({ preventScroll: true }));
    } else if (!isSuppressed()) {
      window.setTimeout(openPromo, delay);
    }

    if (window.Shopify?.designMode) {
      document.addEventListener("shopify:section:select", (event) => {
        if (event.target.contains(promo)) openPromo();
      });
      document.addEventListener("shopify:section:deselect", (event) => {
        if (event.target.contains(promo)) closePromo(false);
      });
    }
  });

  // ─── Custom crosshair cursor ─────────────────────────────────────────────────
  // Only runs on devices that support hover (desktop/laptop — not touch)

  const supportsHover =
    window.matchMedia("(hover: hover) and (pointer: fine)").matches &&
    document.body.dataset.customCursor === "true";

  if (supportsHover) {
    // Build cursor DOM
    const cursor = document.createElement("div");
    cursor.className = "rush-cursor rush-cursor--hidden";
    cursor.innerHTML = `
      <div class="rush-cursor__ring"></div>
      <div class="rush-cursor__crosshair">
        <div class="rush-cursor__dot"></div>
      </div>
    `;
    document.body.appendChild(cursor);

    // Selectors that trigger the hover state
    const HOVER_TARGETS =
      "a, button, [role='button'], label, select, " +
      ".rush-product-card, .rush-category-tile, .rush-customizer-card, " +
      ".rush-blueprint-card, .rush-community-logo, .rush-feature-panel, " +
      ".rush-gallery__thumb, .rush-shop-category__item, .rush-cinch-hero";

    // Selectors that trigger the text cursor state
    const TEXT_TARGETS = "input, textarea, [contenteditable]";

    let mouseX = 0;
    let mouseY = 0;
    let rafId = null;

    // Smooth follow using rAF — ring lags slightly behind crosshair via CSS transitions
    function moveCursor() {
      cursor.style.transform = `translate(${mouseX}px, ${mouseY}px)`;
      rafId = null;
    }

    document.addEventListener("mousemove", (e) => {
      mouseX = e.clientX;
      mouseY = e.clientY;
      cursor.classList.remove("rush-cursor--hidden");
      if (!rafId) rafId = requestAnimationFrame(moveCursor);
    }, { passive: true });

    // Hide cursor when mouse leaves the window
    document.addEventListener("mouseleave", () => {
      cursor.classList.add("rush-cursor--hidden");
    });

    document.addEventListener("mouseenter", () => {
      cursor.classList.remove("rush-cursor--hidden");
    });

    // Hover state — uses event delegation for performance
    document.addEventListener("mouseover", (e) => {
      if (e.target.closest(TEXT_TARGETS)) {
        cursor.classList.add("rush-cursor--text");
        cursor.classList.remove("rush-cursor--hovering");
        return;
      }
      cursor.classList.remove("rush-cursor--text");
      if (e.target.closest(HOVER_TARGETS)) {
        cursor.classList.add("rush-cursor--hovering");
      }
    });

    document.addEventListener("mouseout", (e) => {
      if (!e.target.closest(HOVER_TARGETS) && !e.target.closest(TEXT_TARGETS)) {
        cursor.classList.remove("rush-cursor--hovering", "rush-cursor--text");
      }
      // Re-evaluate on the element we moved to
      const to = e.relatedTarget;
      if (to) {
        if (to.closest(TEXT_TARGETS)) {
          cursor.classList.add("rush-cursor--text");
          cursor.classList.remove("rush-cursor--hovering");
        } else if (to.closest(HOVER_TARGETS)) {
          cursor.classList.add("rush-cursor--hovering");
          cursor.classList.remove("rush-cursor--text");
        } else {
          cursor.classList.remove("rush-cursor--hovering", "rush-cursor--text");
        }
      }
    });

    // Click state — brief squeeze animation on mousedown
    document.addEventListener("mousedown", () => {
      cursor.classList.add("rush-cursor--clicking");
    });

    document.addEventListener("mouseup", () => {
      cursor.classList.remove("rush-cursor--clicking");
    });
  }
})();
